import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className="text-center mt-5">404 Not Found!</h1>
        </div>
    );
};

export default NotFound;